/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { Header, Footer, Loading, Paginate } from '../../../components/index'
import { WebApi } from '../../../api/web'
import { NumberWithCommas } from '../../../utilities/generator'
import { BiMapAlt } from 'react-icons/bi'
import { FiMapPin, FiShoppingCart } from 'react-icons/fi'
const Cart = () => {
  const [profileProducts, setprofileProducts] = useState(null)
  const [loading, setLoading] = useState(false)
  const [totalPage, setTotalPage] = useState(1)
  const [page, setPage] = useState(1)

  useEffect(() => {
    getProducts()
  }, [page])

  const getProducts = async () => {
    setLoading(true)
    await WebApi.orderList(page)
      .then((res) => {
        setLoading(false)
        setprofileProducts(res.data.data.orderList.data)
        setTotalPage(res.data.data.orderList.totalPages)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  return (
    <>
      <Header title='خریدهای من' />
      {loading && <Loading />}
      <div className='container'>
        <div className='template-pages'>
          {profileProducts ? (
            <>
              {profileProducts.length > 0 ? (
                <>
                  {' '}
                  {profileProducts.reverse().map((order) => (
                    <>
                      <a
                        href={`/product-list/${order._id}`}
                        className='order-list'
                      >
                        <div>
                          <div className='d-flex justify-content-between'>
                            <div className='item'>
                              <span>
                                <BiMapAlt />
                              </span>
                              <span className='nav-c'>کد پیگیری :</span>
                              <span>{order.trackingCode}</span>
                            </div>
                            <div>
                              <span
                                style={{
                                  color:
                                    order.statusPayment == 2 ? 'green' : 'red',
                                }}
                              >
                                {order.statusPayment == 2 ? 'موفق' : 'ناموفق'}
                              </span>
                            </div>
                          </div>
                          <div className='item'>
                            <span>
                              <FiShoppingCart />
                            </span>
                            <span className='nav-c'>
                              تعداد محصولات خریداری شده :
                            </span>
                            <span>
                              {order.products.map((product) => product.count++)}
                              عدد
                            </span>
                          </div>
                          {order.city && (
                            <div className='item'>
                              <span>
                                <FiMapPin />
                              </span>
                              <span className='nav-c'>ارسال به :</span>
                              <span>{order.city.title}</span>
                            </div>
                          )}
                          <div className='price'>
                            <span className='pl-2'>کل هزینه :</span>
                            <span className='amount'>
                              {NumberWithCommas(order.amount)}
                            </span>
                            <span>تومان</span>
                          </div>
                        </div>
                      </a>
                    </>
                  ))}
                  <Paginate {...{ totalPage, page, setPage }} />
                </>
              ) : (
                <h5 className='empty-alert'>شما هیچ خریدی ندارید!</h5>
              )}
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Cart
